import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { convertToSearchCriteria } from 'helpers/api';
import {
  getDepositListStart,
  getDepositListSuccess,
  getDepositListFailed,
  getDepositByIdStart,
  getDepositByIdSuccess,
  getDepositByIdFailed,
  getDepositPaymentByIdStart,
  getDepositPaymentByIdSuccess,
  getDepositPaymentByIdFailed,
  editDepositStart,
  editDepositSuccess,
  editDepositFailed,
  editDepositPaymentByIdStart,
  editDepositPaymentByIdSuccess,
  editDepositPaymentByIdFailed,
} from 'redux/actions/deposits';


export const getDepositListApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getDepositListStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/deposits/search?${params}`);
    dispatch(getDepositListSuccess(data));
  } catch (e) {
    dispatch(getDepositListFailed(e));
  }
};

export const getDepositByIdApi = async ({ dispatch, id }) => {
  try {
    dispatch(getDepositByIdStart());
    const { data } = await api.get(`${shopManagerApi}/store/deposits/${id}`);
    dispatch(getDepositByIdSuccess(data));
  } catch (e) {
    dispatch(getDepositByIdFailed(e));
  }
};

export const getDepositPaymentByIdApi = async ({ dispatch, id }) => {
  try {
    dispatch(getDepositPaymentByIdStart());
    const { data } = await api.get(`${shopManagerApi}/store/deposits/payment/${id}`);
    dispatch(getDepositPaymentByIdSuccess(data));
  } catch (e) {
    dispatch(getDepositPaymentByIdFailed(e));
  }
};

export const editDepositApi = async ({dispatch, deposit}) => {
  try {
    dispatch(editDepositStart());
    const { data } = await api.put(`${shopManagerApi}/store/deposits`, deposit);
    dispatch(editDepositSuccess(data));
  } catch (e) {
    dispatch(editDepositFailed(e));
  }
};

export const editDepositPaymentByIdApi = async ({dispatch, payment}) => {
  try {
    dispatch(editDepositPaymentByIdStart());
    const { data } = await api.put(`${shopManagerApi}/store/deposits/payment`, payment);
    dispatch(editDepositPaymentByIdSuccess(data));
  } catch (e) {
    dispatch(editDepositPaymentByIdFailed(e));
  }
};

